import React from 'react';
import { PropTypes } from 'prop-types';
import { StyledIcon } from './Styles';

export const Icon = ({ icon, size, onClick, iconOnly, style, children }) => {
  return (
    <StyledIcon
      size={size}
      className={`fa fa-${icon}`}
      aria-hidden={true}
      onClick={onClick}
      iconOnly={iconOnly}
      style={style}
    >
      {children}
    </StyledIcon>
  );
};

Icon.defaultProps = {
  size: 2,
  onClick: () => null,
  iconOnly: false,
  style: null,
};

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  iconOnly: PropTypes.bool,
  style: PropTypes.string,
};

export default Icon;
